import RegisterFiscalRegimeError from './RegisterFiscalRegimeError';
class FiscalRegimeAlreadyInProcess extends RegisterFiscalRegimeError {
    constructor(options) {
        super('Investor has fiscal regime in process', options);
    }
}
export default FiscalRegimeAlreadyInProcess;
